import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CaseManagementService } from '../../services/case-management.service';

@Component({
  selector: 'app-cases-management-dashboard',
  template: require('./cases-management-dashboard.component.html'),
  styles: [require('./cases-management-dashboard.component.css')]
})
export class CasesManagementDashboardComponent implements OnInit {

    stats: any = {} as any;
    isLoading: boolean = false;
    cases: any = [];

    constructor(private router: Router, private caseManagementService: CaseManagementService) { }

    ngOnInit() {
        this.caseManagementService.getStats().subscribe(r => {
            console.log(r)
            if (r) {
                this.stats = r
            }
        })

        this.getAllCaseDashboard()

    }

    onRefreshCase() {
        this.getAllCaseDashboard()
    }

    getAllCaseDashboard() {
        this.cases = []
        this.isLoading = true
        this.caseManagementService.getAllCaseDashboard().subscribe(r => {
            if (r) {
                let caseArr = r.map(i => i.caseNum)
                this.cases = r;
                //console.log(r)
                this.isLoading = true;
                this.caseManagementService.getLastNotes(caseArr).subscribe(res => {
                    r.forEach(i => {
                        i.cmNote = res.find(e => e.caseNum == i.caseNum);
                    })
                    console.log(r);
                    this.cases = r;
                    this.isLoading = false;
                })
            }
        })
    }


    goCaseManagement(row) {
        this.router.navigate(['/case-management', row.caseNum])
        return true;
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/cases-management-dashboard/cases-management-dashboard.component.ts